import { createSlice } from "@reduxjs/toolkit";
import * as R from "ramda";

import { remUserData, userFormModel } from "./models/userModels";

import { ALLFITLERS, EDITUSER, NEWUSER } from "./userConstants";

const initialState = {
  status: NEWUSER,
  id: "",
  // list
  list: [],
  airports: [],

  allList: [],
  asc: true,
  sort: "date",
  filter: {
    group: "",
    status: "",
  },
  page: 1,
  listSize: 5,
  //
  tags: [],
  countries: [],
  //  form
  form: userFormModel,
  curUser: {
    user: {},
    userAssignments: [],
  },
  //
  airlineGroups: [],
};
//

const filterByPath = (path, value) => {
  return R.filter((item) => R.pathOr(null, path)(item) === value);
};

const sortByPropTitle = (prop, asc) =>
  asc
    ? R.sortWith([R.ascend(R.compose(R.identity, R.pathOr("N/A", prop)))])
    : R.sortWith([R.descend(R.compose(R.identity, R.pathOr("N/A", prop)))]);

const filterByPropValue = (prop, val) =>
  R.filter((item) => R.prop(prop)(item) === val);

function filterListByPath(state, action) {
  // const {path,crew} = action.payload;

  const newGroup =
    action.payload.group !== "" ? action.payload.group : ALLFITLERS;

  const newStatus =
    action.payload.status !== "" ? action.payload.status : ALLFITLERS;

  const isAllGroup = newGroup === ALLFITLERS;
  const isAllStatus = newStatus === ALLFITLERS;

  let list = state.allList;
  let newList = R.filter((item) => {
    const groupCondition = isAllGroup
      ? true
      : R.pathOr(null, ["role"])(item) === newGroup;
    const statusCondition = isAllStatus
      ? true
      : R.pathOr(null, ["is_deleted"])(item) === newStatus;
    return statusCondition && groupCondition;
  })(list);

  state.list = newList;
  state.filter.group = newGroup;
  state.filter.status = newStatus;
}

function sortingList(state, action) {
  const list = state.list;
  const sort = state.sort;
  const asc = state.asc;
  const bysort = action.payload;
  const bySortTitle = action.payload[0];

  if (sort !== bySortTitle) {
    const newSorted = sortByPropTitle(bysort, true)(list);
    state.list = newSorted;
    state.asc = true;
    state.sort = bySortTitle;
  } else {
    const newSorted = sortByPropTitle(bysort, !asc)(list);

    state.list = newSorted;
    state.asc = !asc;
  }
  state.page = 1;
}

const serachProp = (prop, val) =>
  R.compose(R.includes(val), R.toLower, R.propOr("N/A", prop));

const userSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    setUser: (state, action) => {
      console.log(action.payload);
      const fixedData = remUserData(action.payload);
      console.log("🚀 ~ file: userSlice.js ~ line 105 ~ fixedData", fixedData);
      const newData = { ...userFormModel, ...fixedData };
      state.form = newData;
      state.status = EDITUSER;
      state.id = action.payload.id;
    },

    setForminit: (state, action) => {
      state.form = userFormModel;
      state.status = NEWUSER;
      state.id = "";
    },

    setStatus: (state, action) => {
      state.status = action.payload;
    },

    setTagsInUsers: (state, action) => {
      state.tags = action.payload;
    },
    setCountriesInUser: (state, action) => {
      state.countries = action.payload;
    },

    setAirlineGroups: (state, action) => {
      const permissions = action.payload?.filter((permission) => {
        return permission.title !== "admin";
      });
      state.airlineGroups = permissions;
    },

    handleFormChange: (state, action) => {
      const { key, value } = action.payload;
      state.form[key] = value;
    },

    // List

    setUserList: (state, action) => {
      // state.status = NEWTAG;
      // state.tag = { id: "", description: "" };
      state.list = action.payload;
      state.allList = action.payload;
    },

    setUserPage: (state, action) => {
      state.page = action.payload;
    },

    resetUserList: (state, action) => {
      const allList = state.allList;
      state.list = allList;
      state.filter.group = "";
      state.filter.status = "";
    },

    setUserListSize: (state, action) => {
      state.page = 1;
      state.listSize = action.payload;
    },
    sortUserListBy: sortingList,

    filterUserList: (state, action) => {
      const all = state.allList;
      const { name, value } = action.payload;
      if (value === "all") {
        state.list = all;
      } else {
        const filtered = filterByPropValue(name, value)(all);
        state.list = filtered;
      }
      state.page = 1;
      state.sort = "date";
      state.asc = true;
    },
    filterUserByText: (state, action) => {
      const text = action.payload;
      let list = state.allList;
      let newList = R.filter((item) => {
        const codeCondition = serachProp("username", text)(item);
        const firstCondition = serachProp("first_name", text)(item);
        const lastCondition = serachProp("last_name", text)(item);

        return codeCondition || firstCondition || lastCondition;
      })(list);
      state.list = newList;
      state.filter.group = "";
      state.filter.status = "";
    },

    filterUser: filterListByPath,

    setCurrentUser: (state, action) => {
      state.curUser = action.payload;
    },
    setAirports: (state, action) => {
      state.airports = action.payload;
    },
  },
});

export const { actions } = userSlice;
export const {
  setStatus,
  setUser,
  handleFormChange,
  setForminit,
  setTagsInUsers,
  setCountriesInUser,
  // list
  setUserList,
  setUserListSize,
  setUserPage,
  filterUserList,
  sortUserListBy,
  setCurrentUser,
  setAirports,
  filterUserByText,
  resetUserList,
  filterUser,
} = actions;

export const onUserFormChange = (key, value) => (dispatch) => {
  return dispatch(handleFormChange({ key, value }));
};

export const userForminit = () => (dispatch) => {
  return dispatch(setForminit());
};

// export const sendTagForEdit = (item) => (dispatch) => {
//   return dispatch(setTagToEdit(item));
// };
// export const resetTagForm = () => (dispatch) => {
//   return dispatch(setFormInit());
// };

// selectors
export const selUsersList = (state) => state?.users?.list;
export const selUserPage = (state) => state.users.page;
export const selUsersSize = (state) => state.users.listSize;
export const selUserSort = (state) => state.users.sort;
export const selUserasc = (state) => state.users.asc;

export const selUsersStutus = (state) => state.users.status;
export const selUserId = (state) => state.users.id;
export const selTagsInUsers = (state) => state.users.tags;
export const selCountriesInUser = (state) => state.users.countries;

export const selUserFormStatus = (state) => state.users.status;
export const selUserform = (state) => state.users.form;
export const selAirlineGroups = (state) => state.users.airlineGroups;
export const selCurrentUser = (state) => state.users.curUser;
export const selAirports = (state) => state.users.airports;

export const selUserTableFilter = (state) => state.users.filter;

const reducer = {
  users: userSlice.reducer,
};

export default reducer;
